<template>
  <div class="user_detail_page">
    <pageTitle />
    <business-group ref="businessGroup" :tableConfig="{...tableConfig}" :formConfig="{...formConfig}">
      <template slot="formRight">
        <a-button type="primary" @click="add">新增</a-button>
      </template>
      <template slot="action" slot-scope="record">
        <a-button type="link" @click="edit(record)">编辑</a-button>
        <a-button type="link" style="color: red" @click="del(record)">删除</a-button>
      </template>
    </business-group>
    <a-modal
      :title="title"
      destroyOnClose
      :width="350"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      :maskClosable="false"
    >
      <a-form layout="inline" style="text-align: center">
        <a-form-item label="职业名称">
          <a-input v-model="value"  placeholder="请输入职业名称"/>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { confirm, tips } from "@/utils/util";
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";

const columns = [
  {
    title: "职业",
    dataIndex: "jobName",
    key: "jobName"
    // align: "center",

  },
  {
    title: "操作",
    align: "center",
    width: 180,
    scopedSlots: { customRender: "action" }
  }
];


export default {
  components: {
    pageTitle,
    businessGroup
  },
  data() {
    return {

      tableConfig: {
        url: "/bluetoothlight/web/other/jobs",
        columns,
        rowKey: "jobId",
        loading: false
      },
      formConfig: {
        formShow: false
      },
      visible: false,
      confirmLoading: false,
      value: "",
      record: undefined,
      title: ""
    };
  },
  created() {

  },
  methods: {
    handleDlete(e) {
      console.log(e);
      let _this = this;

      this.$confirm({
        title: "确定要删除该职业吗",
        onOk() {
          Deletejobs(e.jobId)
            .then((res) => {
              console.log("55", res);
              if (res.resultStatus) {
                _this.$message.success("删除成功");
                _this.getData();
              } else {
                _this.$message.warn(res.errorMessage);
              }
            })
            .catch((err) => {
              console.error(err);
              // _this.$message.error("请求失败");
            })
            .finally(() => {

            });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test"
      });
    },
    refreshData() {
      this.$refs?.["businessGroup"]?.getData?.();
    },

    _post: async function() {
      if (this.confirmLoading) return false;
      this.confirmLoading = true;
      const jobId = this.record?.jobId || 0;
      const res = await this.$post(`bluetoothlight/web/other/jobs/${jobId}`, {
        jobName: this.value
      });
      const resultStatus = res?.resultStatus;
      if (resultStatus) {
        tips(this, true);
        this.refreshData();
        this.handleCancel();
      }

      this.confirmLoading = false;
    },


    handleOk() {
      console.log(this.value, "value");
      if (this.value === "") {
        tips(this, false, "请输入职业名称");
        return false;
      }

      this._post();

    },
    handleCancel() {
      this.visible = false;
      this.value = undefined;
      this.record = undefined;
    },
    edit(record) {
      if (!record) {
        tips(this, false, "数据异常,请稍后重试");
        return false;
      }
      this.title = "请修改职业";
      this.record = record;
      this.value = record?.jobName;
      this.visible = true;
    },
    add() {
      this.title = "新增职业";
      this.visible = true;
    },
    del(record) {
      const jobId = record?.jobId;
      if (!jobId || this.confirmLoading) return false;
      this.confirmLoading = true;
      const payload = {
        okBack: async () => {
          const res = await this.$http("DELETE", `bluetoothlight/web/other/jobs/${jobId}`);
          const resultStatus = res?.resultStatus;
          if (resultStatus) {
            tips(this, true);
            this.refreshData();
          }
        },
        title: `确认删除${record?.jobName}职业吗`
      };
      confirm(this, payload);
      setTimeout(() => {
        this.confirmLoading = false;
      }, 400);
    }
  }
};
</script>

